import 'whatwg-fetch'
import 'custom-event-polyfill'
import 'core-js/stable/promise'
import 'core-js/stable/symbol'
import 'core-js/stable/string/starts-with'
import 'core-js/web/url'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { isBookingEntry } from '@/utils/bookingAccess'
import { registerMicroApps, start } from 'qiankun'
import actions from '@/actions'
import i18n, { getLanguage, setLanguage } from '@/i18n'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

import './style/main.scss'

Vue.config.productionTip = false

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

const language = setLanguage(getLanguage())
store.commit('user/setLanguage', language)

let HOST = ''
let HOSTNAME = ''
let PROTOCOL = ''
let PATHNAME = ''
let IS_DEV = false

// 如果页面正常打开，替换域名中 [www, app] 为 ''，用于适配指向子应用配置的域名
if (typeof window !== 'undefined') {
  HOSTNAME = window.location.hostname
  PROTOCOL = window.location.protocol
  PATHNAME = window.location.pathname
  HOST = window.location.host.replace('www', '').replace('app', '')

  // 本地开发模式
  if (HOSTNAME == 'localhost') {
    IS_DEV = true
    PROTOCOL = HOSTNAME == 'localhost' ? 'http:' : PROTOCOL
    HOST = HOSTNAME == 'localhost' ? '.eline56.test/' : HOST
  }
}

// 调试总开关 IS_DEV: true - 本地调试  false - 线上模式
// 子组件调试开关
const devMode = {
  user: IS_DEV ? 'dev' : 'line',
  track: IS_DEV ? 'line' : 'line',
  cpsqd: IS_DEV ? 'line' : 'line',
  cps: IS_DEV ? 'line' : 'line',
  vgm: IS_DEV ? 'line' : 'line',
  aci: IS_DEV ? 'line' : 'line',
  afr: IS_DEV ? 'line' : 'line',
  ams: IS_DEV ? 'line' : 'line',
  isf: IS_DEV ? 'line' : 'line',
  ics: IS_DEV ? 'line' : 'line',
  mpci: IS_DEV ? 'line' : 'line',
  em: IS_DEV ? 'line' : 'line',
  // 订舱子应用联调开关：默认 line（指向 cargo-booking.<域名>）。
  // 本地联调订舱前端时显式指定 VUE_APP_BOOKING_ENTRY，如：
  //   VUE_APP_BOOKING_ENTRY=http://localhost:5173 npm run serve
  // 不指定时即使子应用 dev server 没起也不会误连本地地址。
  booking: process.env.VUE_APP_BOOKING_ENTRY || 'line'
}
console.log('ICS', devMode['ics'])

// 订舱子应用入口。历史约定是按门户域名推导：//cargo-booking<门户域>，
// 测试/预发/本地继续沿用（如 app.eline56.test -> cargo-booking.eline56.test）。
// 正式环境的订舱子应用已独立部署在 booking.uifox.com.cn，与门户域不同后缀，
// 推导结果（cargo-booking.<门户域>）是错的，因此按门户域名显式映射，未命中则退回推导。
// 注意：这件事不能放进 VUE_APP_* 环境变量——门户所有环境共用一份 production 构建
//（.env.production 的值会同时落到测试环境），环境差异只能按运行时域名判断。
const BOOKING_ENTRY_BY_PORTAL_HOST = {
  'eline56.com': 'https://booking.uifox.com.cn/',
  'uifox.com.cn': 'https://booking.uifox.com.cn/'
}
const resolveBookingEntry = () => {
  if (devMode.booking !== 'line') return devMode.booking
  const matchedHost = Object.keys(BOOKING_ENTRY_BY_PORTAL_HOST).find(domain => HOSTNAME === domain || HOSTNAME.endsWith('.' + domain))
  return matchedHost ? BOOKING_ENTRY_BY_PORTAL_HOST[matchedHost] : PROTOCOL + '//cargo-booking' + HOST
}

const conf = {
  user: {
    entry: devMode.user === 'line' ? PROTOCOL + '//user' + HOST : 'http://localhost:3020/'
  },
  home: {
    entry: PROTOCOL + '//home' + HOST
  },
  rpaControl: {
    entry: PROTOCOL + '//rpastore' + HOST
  },
  agent: {
    entry: PROTOCOL + '//agency' + HOST
  },
  grab: {
    entry: PROTOCOL + '//grab' + HOST
  },
  apistore: {
    entry: PROTOCOL + '//apistore' + HOST
  },
  track: {
    entry: devMode.track === 'line' ? PROTOCOL + '//track' + HOST : 'http://localhost:3000/'
  },
  cps: {
    entry: devMode.cps === 'line' ? PROTOCOL + '//cps' + HOST : 'http://localhost:3100/'
  },
  cpsqd: {
    entry: devMode.cpsqd === 'line' ? PROTOCOL + '//cpsqd' + HOST : 'http://localhost:3200/'
  },
  vgm: {
    entry: devMode.vgm === 'line' ? PROTOCOL + '//vgm' + HOST : 'http://localhost:3300/'
  },
  em: {
    entry: devMode.em === 'line' ? PROTOCOL + '//em' + HOST : 'http://localhost:3400/'
  },
  aci: {
    entry: devMode.aci === 'line' ? PROTOCOL + '//aci' + HOST : 'http://localhost:3401/'
  },
  afr: {
    entry: devMode.afr === 'line' ? PROTOCOL + '//afr' + HOST : 'http://localhost:3402/'
  },
  ams: {
    entry: devMode.ams === 'line' ? PROTOCOL + '//ams' + HOST : 'http://localhost:3403/'
  },
  isf: {
    entry: devMode.isf === 'line' ? PROTOCOL + '//isf' + HOST : 'http://localhost:3404/'
  },
  ics: {
    entry: devMode.ics === 'line' ? PROTOCOL + '//ics' + HOST : 'http://localhost:3406/'
  },
  mpci: {
    entry: devMode.mpci === 'line' ? PROTOCOL + '//mpci' + HOST : 'http://localhost:3405/'
  },
  freight: {
    entry: PROTOCOL + '//freight' + HOST
  },
  blenter: {
    entry: PROTOCOL + '//blenter' + HOST
  },
  tracking: {
    entry: PROTOCOL + '//tracking' + HOST
  },
  booking: {
    // devMode.booking 为 'line' 时按门户域名解析线上 entry；否则视为本地 dev server 完整地址
    entry: resolveBookingEntry()
  }
}

Vue.prototype.$trackingEntry = conf.tracking.entry

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

const getMicroAppProps = () => ({
  data: store,
  language: store.getters.language,
  lang: store.getters.language,
  // 供子应用监听主应用全局状态（如消息已读后刷新消息中心）
  onGlobalStateChange: actions.onGlobalStateChange,
  setGlobalState: actions.setGlobalState
})

registerMicroApps([
  {
    name: 'wise-user-center',
    entry: conf.user.entry, // https://user.eline56.com/user/register
    container: '#appContainer',
    activeRule: '/user',
    props: getMicroAppProps()
  },
  // {
  //   name: 'wise-home', // 跳板子应用，当访问无效页面时，重定向到首页
  //   entry: conf.home.entry,
  //   container: '#appContainer',
  //   activeRule: '/home',
  //   props: { data: store }
  // },
  // {
  //   name: 'wise-rpa-control',
  //   entry: conf.rpaControl.entry,
  //   container: '#appContainer',
  //   activeRule: '/rpaControl',
  //   props: { data: store }
  // },
  {
    name: 'wise-agent',
    entry: conf.agent.entry,
    container: '#appContainer',
    activeRule: '/agent',
    props: getMicroAppProps()
  },
  // {
  //   name: 'wise-apistore',
  //   entry: conf.apistore.entry,
  //   container: '#appContainer',
  //   activeRule: '/apistore',
  //   props: { data: store }
  // },
  // {
  //   name: 'wise-blenter',
  //   entry: conf.blenter.entry,
  //   container: '#appContainer',
  //   activeRule: '/blenter',
  //   props: { data: store }
  // },
  {
    name: 'wise-cps',
    entry: conf.cps.entry,
    container: '#appContainer',
    activeRule: '/cps',
    props: getMicroAppProps()
  },
  {
    name: 'wise-cpsqd',
    entry: conf.cpsqd.entry,
    container: '#appContainer',
    activeRule: '/cpsqd',
    props: getMicroAppProps()
  },
  {
    name: 'wise-track',
    entry: conf.track.entry,
    container: '#appContainer',
    activeRule: location => /^\/(track|boxTracking)(\/|$)/.test(location.pathname),
    props: getMicroAppProps()
  },

  {
    name: 'wise-vgm',
    entry: conf.vgm.entry,
    container: '#appContainer',
    activeRule: '/vgm',
    props: getMicroAppProps()
  },
  {
    name: 'wise-freight',
    entry: conf.freight.entry,
    container: '#appContainer',
    activeRule: '/freight',
    props: getMicroAppProps()
  },
  {
    name: 'wise-booking',
    entry: conf.booking.entry,
    container: '#appContainer',
    activeRule: location => isBookingEntry(location.pathname) && store.getters['bookingAccess/access'] === 'ELIGIBLE',
    props: getMicroAppProps()
  },
  {
    name: 'wise-em',
    entry: conf.em.entry,
    container: '#appContainer',
    activeRule: '/em',
    props: getMicroAppProps()
  },
  {
    name: 'wise-aci',
    entry: conf.aci.entry,
    container: '#appContainer',
    activeRule: '/aci',
    props: getMicroAppProps()
  },
  {
    name: 'wise-afr',
    entry: conf.afr.entry,
    container: '#appContainer',
    activeRule: '/afr',
    props: getMicroAppProps()
  },
  {
    name: 'wise-ams',
    entry: conf.ams.entry,
    container: '#appContainer',
    activeRule: '/ams',
    props: getMicroAppProps()
  },
  {
    name: 'wise-isf',
    entry: conf.isf.entry,
    container: '#appContainer',
    activeRule: '/isf',
    props: getMicroAppProps()
  },
  {
    name: 'wise-ics',
    entry: conf.ics.entry,
    container: '#appContainer',
    activeRule: '/ics',
    props: getMicroAppProps()
  },
  {
    name: 'wise-mpci',
    entry: conf.mpci.entry,
    container: '#appContainer',
    activeRule: '/mpci',
    props: getMicroAppProps()
  }
])

// 直达订舱必须等资格确认后才能挂载子应用；其他产品不改变启动时机。
const bookingReady = store.dispatch('bookingAccess/refresh')
if (isBookingEntry(location.pathname)) {
  bookingReady.then(access => {
    if (access !== 'ELIGIBLE') router.replace('/introduce/booking')
    start()
  })
} else {
  start()
}
